export const UserManagementErrorCode = {
    DuplicateUserName: "DuplicateUserName",
} as const;

export type UserManagementErrorCode =
    typeof UserManagementErrorCode[keyof typeof UserManagementErrorCode];